import { http } from './http';
import { CommercialPlan } from 'types';

export const getCommercialPlan = (plan_id: string): Promise<CommercialPlan> =>
  http.get(`commercial_plan/${plan_id}`);

export const getCommercialPlansWithFeatures = () =>
  http.get(`commercial_plan/features`);
